import { User } from './user.model';
import { UserRole } from '../enums/user-role.enum';
import { Theme } from '@sb-tools/typescript/enums/theme.enum';
import { BlockedUserInfo } from '@sb-tools/typescript/models/blocked-user-info.model';

export class CommunityUser extends User {
    assignedToApi: boolean;
    assignedToAppStore: boolean;
    assignedToChat: boolean;
    assignedToEmail: boolean;
    assignedToFacebook: boolean;
    assignedToForm: boolean;
    assignedToGoogleMyBusiness: boolean;
    assignedToGooglePlayMarket: boolean;
    assignedToInstagram: boolean;
    assignedToTikTok: boolean;
    assignedToTrustpilot: boolean;
    assignedToWhatsApp: boolean;
    assignedToYoutube: boolean;
    attentionEmailSentDate?: Date;
    blockingInfo: BlockedUserInfo;
    chatAliasImage: string;
    chatAliasIsActive: boolean;
    chatAliasName: string;
    color: string;
    communityId: number; // is using?
    dailyAlert: boolean;
    hasAccessToFAQ: boolean;
    hasAccessToGDPR: boolean;
    isAdmin: boolean;
    isCommunitySignatures: boolean;
    isManager: boolean;
    isOrWasTeamMember: boolean;
    isOwner: boolean;
    isReadOnlyUser: boolean;
    isReplyWebNotificationEnabled: boolean;
    isStaff: boolean;
    isSurveyResponseWebNotificationEnabled: boolean;
    isSystemAdmin: boolean;
    isTeamMember: boolean;
    isTicketMovedToUserCategoryAlertEnabled: boolean;
    label?: string; // gui only
    role: UserRole;
    socialMediaLink?: string;
    theme: Theme;
    ticketAlert: boolean;
    ticketAssignmentAlert: boolean;
    whatsAppId: any;
}
